import {Form, FormikProps} from "formik";
import React from "react";
import Input from "../../Elements/Form/Input";
import Button from "../../Elements/Button";
import {IAuthCodeData} from "../../../contracts/data/auth";
import Timer from "../../Timer";
import httpClient from "../../../services/httpClient";
import {authApi} from "../../../constans/apiUrls";


const InnerAuthCodeForm = (props:FormikProps<IAuthCodeData>) => {
    const [resend, setResend] = React.useState(false)

    const handleResendCodeClick = async () => {
        await httpClient().post(authApi.resend_code, {mobile: props?.status?.mobile})
            .then(response => {
                if(response.status === 200){
                    setResend(false)
                }
            })
            .catch(error => console.log(error))
    }

    return(
        <Form className={"grow flex flex-col justify-between"}>
            <div>
                <div>
                    <div className={"mb-6"}>
                        <h2 className={"text-2xl text-semibold tracking-tight mb-6"}>کد تایید را وارد کنید</h2>
                    </div>
                    <Input
                        name={"code"} label={`کد تایید برای شماره ${props?.status?.mobile} پیامک شد`}
                        placeholder={"کد تایید"} meta={props?.getFieldMeta("code")} />
                </div>
                <div>
                    {resend? <div className={"text-center text-blue-400 text-md cursor-pointer hover:text-blue-300 py-2"} onClick={handleResendCodeClick}>ارسال مجدد کد</div> : <Timer handleResend={setResend} start_seconds={0} start_minutes={1} />}
                </div>
            </div>
            <div>
                <Button title={"تایید"} btnClassName={"w-full"} isLoading={props.isSubmitting} />
            </div>
        </Form>
    )
}

export default InnerAuthCodeForm